////
/// ============================================================================
/// COMPONENT / Tabs
/// ============================================================================
///
/// @group components
////

import debounce from "../utils/debounce";

export default () => {

    let i = 1; // counter for ".js-tabs__nav li" elements

    document.querySelectorAll('.js-tabs').forEach(function (container) {
        let nav = container.querySelector('.js-tabs__nav');
        let navItems = nav.querySelectorAll('li');
        let triggers = container.querySelectorAll('.js-tabs__trigger');
        let panels = container.querySelectorAll('.js-tabs__panel');
        let hash = window.location.hash;

        if (!panels.length) {
            return;
        }

        function displayTab(item) { 

            if (!item) {
                return;
            }

            let panel = getPanelFromItem(item);

            openPanel(panel);
        }

        function togglePanel(trigger) {
            let panel = getPanelFromTrigger(trigger);

            if (!panel) {
                return;
            }

            if (panel.classList.contains('is-open')) {
                closePanel(panel);
            } else {
                openPanel(panel);
            }
        }

        function openPanel(panel) {
            if (!isValidPanel(panel)) {
                return false;
            }

            navItems.forEach(function (el) {
                el.classList.remove('is-active');
            });

            panels.forEach(function (el) {
                el.classList.remove('is-open');
            });

            panel.classList.add('is-open');

            let trigger = findTrigger(panel);

            if (trigger) {
                trigger.classList.add('is-open');
            }

            let item = container.querySelector('#' + panel.getAttribute('aria-labelledby'));
            item.classList.add('is-active');

            return true;
        }

        function closePanel(panel) {
            if (panel) {
                panel.classList.remove('is-open');

                let trigger = findTrigger(panel);
                if (trigger) {
                    trigger.classList.remove('is-open');
                }
            }
        }

        function findTrigger(panel) {
            let trigger = panel.previousElementSibling;

            if (trigger && trigger.classList.contains('js-tabs__trigger')) {
                return trigger;
            }

            return null;
        }

        function getPanelFromItem(item) {
            let panelSelector = '#' + item.getAttribute('aria-controls');

            if (panelSelector) {
                return container.querySelector(panelSelector);
            }

            return null;
        }

        function getPanelFromTrigger(trigger) {
            return trigger.closest('.js-tabs__panel');
        }

        function isValidPanel(panel) {
            if (!panel) {
                return false;
            }

            for (let i = 0; i < panels.length; i++) {
                if (panels[i] === panel) {
                    return true;
                }
            }

            return false;
        }

        navItems.forEach(function (item) {
            item.addEventListener('click', function (event) {
                event.preventDefault();
                displayTab(item);
            });

            let panel = getPanelFromItem(item);

            if (panel) {
                item.setAttribute('id', 'tab-nav-' + i);
                panel.setAttribute('aria-labelledby', 'tab-nav-' + i);
            }

            i++;
        });

        triggers.forEach(function (trigger) {
            trigger.addEventListener('click', function (event) {
                event.preventDefault();
                togglePanel(trigger);
            });
        });

        if (
            !hash.startsWith("#")
            || !openPanel(container.querySelector(hash))
        ) {

            if (document.querySelector('[aria-controls="tabs-product-description"]')) {
                displayTab(navItems[0]);
            } else {
                displayTab(navItems[2]);
            }

        }

        window.addEventListener('resize', debounce(function () {
            if (window.matchMedia('(min-width: 901px)').matches) {
                let allClose = true;

                panels.forEach(function (panel) {
                    if (panel.classList.contains('is-open')) {
                        allClose = false;
                    }
                });

                if (allClose) {
                    displayTab(navItems[0]);
                }
            }
        }));

        document.addEventListener('click', function (event) {
            const target = event.target;
            if (target.tagName === 'A' && target.hash) {
                // This is an anchor link on the same page
                openPanel(container.querySelector(target.hash));
            }
        });
    });

};
